import React from 'react'
import { useTranslation } from 'react-i18next'

import { Card } from '@/components/ui/card'
import type { ISentimentPercentage } from '@/store/api/Person/Person.types'

interface SentimentBreakDownWidgetTypes {
  overview: string
  sentimentPercentages?: ISentimentPercentage[]
}

export const SentimentBreakDownWidget = ({
  overview,
  sentimentPercentages,
}: SentimentBreakDownWidgetTypes) => {
  const { t } = useTranslation()

  const sentimentOrder: Record<string, number> = {
    Positive: 1,
    Neutral: 2,
    Negative: 3,
  }

  const sortedSentiments = sentimentPercentages
    ? [...sentimentPercentages].sort((a, b) => {
        const orderA = sentimentOrder[a.sentiment] || 999
        const orderB = sentimentOrder[b.sentiment] || 999
        return orderA - orderB
      })
    : undefined

  return (
    <div className="flex flex-col gap-5">
      <Card className="bg-baseColor flex flex-col gap-2 p-4">
        <p className="text-neutralColor text-xl font-medium">
          {t('report.generalInfo.sentimentBreakdown')}
        </p>
        <p className="text-neutralColor80 text-base font-normal">{overview}</p>
      </Card>
      <div className="flex flex-col gap-2">
        <div className="flex flex-row justify-between max-sm:flex-col max-sm:gap-2">
          {sortedSentiments?.map((sentiment, index) => (
            <Card
              key={index}
              className="flex flex-col max-sm:flex-row max-sm:justify-between max-sm: gap-2 w-[30%] p-4 bg-baseColor max-sm:w-full"
            >
              <p className="text-neutralColor text-2xl font-medium">
                {sentiment.percentage.toFixed(2)}%
              </p>
              <div className="flex items-center justify-between  max-sm:gap-2">
                <p className="text-neutralColor80 text-sm font-normal">
                  {sentiment.sentiment}
                </p>
                <div
                  className={`w-2 h-2 rounded-full ${
                    sentiment.sentiment === 'Positive'
                      ? 'bg-dynamicGreen'
                      : sentiment.sentiment === 'Neutral'
                        ? 'bg-dynamicYellow'
                        : 'bg-dynamicRed'
                  }`}
                />
              </div>
            </Card>
          ))}
        </div>
        <p className="text-neutralColor60 text-sm font-normal">
          {t('report.generalInfo.sentimentBreakdownDescription')}
        </p>
      </div>
    </div>
  )
}
